import React, { useState } from "react";
import "./contactus.css";
import Navbar from "../../Common/Navbar/Navbar";
import Footer from "../../Common/Footer/Footer";
import { ToastContainer, toast } from "react-toastify";

const ContactUs = () => {
  const [fname, setFname] = useState("");
  const [lname, setLname] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [phonenumber, setPhonenumber] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const response = await fetch(
        `http://192.168.1.3:3000/admin/contactus/createcontact`,
        {
          method: "POST",
          headers: {
            Authorization:
              "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjY0ODJlNDdhYThiOWRjODhhYzU4NTRkZiIsImlhdCI6MTY4NjMwMDEyMiwiZXhwIjoxNjk0MDc2MTIyfQ.gRGPjduj2EdDkviIqvcth3FSPkIsCbHkZUFal9a7d5A",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            first_name: fname,
            last_name: lname,
            email: email,
            phonenumber: phonenumber,
            message: message,
          }),
        }
      );

      if (response.ok) {
        // Successful registration logic
        toast.success("Data Sent Successfully!", {
          position: "top-right",
          autoClose: 3000, // 3 seconds
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        // Clear form fields after successful submission
        setFname("");
        setLname("");
        setEmail("");
        setMessage("");
        setPhonenumber("");
      } else {
        // Handle registration error
        toast.error("Failed to send data.", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        console.error("Data submission failed.");
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  return (
    <>
      <Navbar />
      <div className="contact-us">
        <div className="form">
          <div className="form-heading">
            <h1 className="foam-heading-title">Contact Us</h1>
            <div className="foam-heading-subtitle">
              Any Questions or remarks? Just Write us a message
            </div>
          </div>
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
          <form className="form-container" onSubmit={handleSubmit}>
            <div className="foam-names">
              <div className="foam-first-name">
                <label className="first-title">First Name*</label>
                <br />
                <input
                  type="text"
                  className="first_name"
                  id="first_name"
                  name="first_name"
                  placeholder="Enter your First Name"
                  value={fname}
                  onChange={(e) => setFname(e.target.value)}
                />
              </div>
              <div className="foam-last-name">
                <label className="last-title">Last Name*</label>
                <br />
                <input
                  type="text"
                  className="last_name"
                  id="last_name"
                  name="last_name"
                  placeholder="Enter your Last Name"
                  value={lname}
                  onChange={(e) => setLname(e.target.value)}
                />
              </div>
            </div>
            <div className="email-container">
              <label className="email-title">Email*</label>
              <input
                type="text"
                id="email"
                name="email"
                placeholder="Enter your Email id"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className="phone-container">
              <label className="phone-label">Phone no.</label>
              <input
                type="number"
                className="phonenumber"
                id="phonenumber"
                name="phonenumber"
                placeholder="Enter your Phone Number"
                value={phonenumber}
                onChange={(e) => setPhonenumber(e.target.value)}
              />
            </div>{" "}
            <div className="message-container">
              <label className="message-label">Write a Message</label>
              <input
                type="text"
                id="message"
                name="message"
                placeholder="Write a Message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              />
            </div>
            <div className="button-container">
              <button className="formbold-btn" onClick={handleSubmit}>
                 Submit
              </button>
            </div>
          </form>
        </div>
      </div>
      <div className="contact-footer">
        <div className="content-container">
          <div className="cf-main-text">
            <div className="section-left-text">
              <div className="left-text-heading">
                Have any concerns ?
              </div>
              <div className="left-small-text">
                Feel free to reach out to us.
              </div>
            </div>
          </div>
          <div className="cf-right-text">
            <div className="cf-right-boxes">
              <div className="cf-box-icon">
                <svg
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8 20V40H32V20H8ZM12 16V8C12 6.93913 12.4214 5.92172 13.1716 5.17157C13.9217 4.42143 14.9391 4 16 4H40C41.0609 4 42.0783 4.42143 42.8284 5.17157C43.5786 5.92172 44 6.93913 44 8V28C44 29.0609 43.5786 30.0783 42.8284 30.8284C42.0783 31.5786 41.0609 32 40 32H36V40C36 41.0609 35.5786 42.0783 34.8284 42.8284C34.0783 43.5786 33.0609 44 32 44H8C6.93913 44 5.92172 43.5786 5.17157 42.8284C4.42143 42.0783 4 41.0609 4 40V20C4 18.9391 4.42143 17.9217 5.17157 17.1716C5.92172 16.4214 6.93913 16 8 16H12ZM16 16H32C33.0609 16 34.0783 16.4214 34.8284 17.1716C35.5786 17.9217 36 18.9391 36 20V28H40V8H16V16ZM16 34C14.4087 34 12.8826 33.3679 11.7574 32.2426C10.6321 31.1174 10 29.5913 10 28C10 26.4087 10.6321 24.8826 11.7574 23.7574C12.8826 22.6321 14.4087 22 16 22C17.5913 22 19.1174 22.6321 20.2426 23.7574C21.3679 24.8826 22 26.4087 22 28C22 29.5913 21.3679 31.1174 20.2426 32.2426C19.1174 33.3679 17.5913 34 16 34ZM16 30C16.5304 30 17.0391 29.7893 17.4142 29.4142C17.7893 29.0391 18 28.5304 18 28C18 27.4696 17.7893 26.9609 17.4142 26.5858C17.0391 26.2107 16.5304 26 16 26C15.4696 26 14.9609 26.2107 14.5858 26.5858C14.2107 26.9609 14 27.4696 14 28C14 28.5304 14.2107 29.0391 14.5858 29.4142C14.9609 29.7893 15.4696 30 16 30ZM18 16C18 14.4087 18.6321 12.8826 19.7574 11.7574C20.8826 10.6321 22.4087 10 24 10C25.5913 10 27.1174 10.6321 28.2426 11.7574C29.3679 12.8826 30 14.4087 30 16H26C26 15.4696 25.7893 14.9609 25.4142 14.5858C25.0391 14.2107 24.5304 14 24 14C23.4696 14 22.9609 14.2107 22.5858 14.5858C22.2107 14.9609 22 15.4696 22 16H18ZM21.728 43.036L18.272 41.022L23.722 31.676C24.1951 30.8644 24.8521 30.1752 25.6402 29.6639C26.4283 29.1527 27.3255 28.8336 28.2594 28.7324C29.1934 28.6312 30.1381 28.7508 31.0174 29.0814C31.8967 29.4121 32.6861 29.9445 33.322 30.636L35.498 33.004L32.552 35.712L30.378 33.344C30.1659 33.1136 29.9027 32.9362 29.6096 32.8261C29.3164 32.716 29.0015 32.6762 28.6901 32.7101C28.3788 32.7439 28.0798 32.8504 27.8171 33.021C27.5545 33.1915 27.3356 33.4214 27.178 33.692L21.728 43.036ZM34.752 17.096C35.875 16.6626 37.1026 16.5777 38.2746 16.8524C39.4466 17.1271 40.5086 17.7487 41.322 18.636L43.498 21.004L40.552 23.712L38.378 21.344C38.0828 21.0228 37.6906 20.8069 37.2613 20.7292C36.832 20.6516 36.389 20.7165 36 20.914V20C36 18.858 35.52 17.826 34.752 17.098V17.096Z"
                    fill="#C1C7CD"
                  />
                </svg>
              </div>
              <div className="cf-box-name">Nodal Officer</div>
              <a href="mailto:resshucoonnect@gmail.com">
              <div className="cf-box-mail">
                <span className="contact-title"> Email</span>
              </div>
              </a>
              <div className="cf-box-contact">
                <div className="contact-title">Contact :</div>
                <a>099099 59447</a>

                {/* <div className="arrow">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15.586 10.6569L11.636 6.70692C11.4538 6.51832 11.353 6.26571 11.3553 6.00352C11.3576 5.74132 11.4628 5.49051 11.6482 5.3051C11.8336 5.11969 12.0844 5.01452 12.3466 5.01224C12.6088 5.00997 12.8614 5.11076 13.05 5.29292L18.707 10.9499C18.8002 11.0426 18.8741 11.1527 18.9246 11.2741C18.9751 11.3954 19.001 11.5255 19.001 11.6569C19.001 11.7883 18.9751 11.9184 18.9246 12.0398C18.8741 12.1611 18.8002 12.2713 18.707 12.3639L13.05 18.0209C12.9578 18.1164 12.8474 18.1926 12.7254 18.245C12.6034 18.2974 12.4722 18.325 12.3394 18.3262C12.2066 18.3273 12.0749 18.302 11.952 18.2517C11.8291 18.2015 11.7175 18.1272 11.6236 18.0333C11.5297 17.9394 11.4555 17.8278 11.4052 17.7049C11.3549 17.582 11.3296 17.4503 11.3307 17.3175C11.3319 17.1847 11.3595 17.0535 11.4119 16.9315C11.4643 16.8095 11.5405 16.6992 11.636 16.6069L15.586 12.6569H6C5.73478 12.6569 5.48043 12.5516 5.29289 12.364C5.10536 12.1765 5 11.9221 5 11.6569C5 11.3917 5.10536 11.1373 5.29289 10.9498C5.48043 10.7623 5.73478 10.6569 6 10.6569H15.586Z"
                      fill="#0F62FE"
                    />
                  </svg>
                </div> */}
              </div>
            </div>
            <div className="cf-right-boxes">
              <div className="cf-box-icon">
                <svg
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M24 40C28.2435 40 32.3131 38.3143 35.3137 35.3137C38.3143 32.3131 40 28.2435 40 24C40 19.7565 38.3143 15.6869 35.3137 12.6863C32.3131 9.68571 28.2435 8 24 8C19.7565 8 15.6869 9.68571 12.6863 12.6863C9.68571 15.6869 8 19.7565 8 24C8 28.2435 9.68571 32.3131 12.6863 35.3137C15.6869 38.3143 19.7565 40 24 40ZM24 44C12.954 44 4 35.046 4 24C4 12.954 12.954 4 24 4C35.046 4 44 12.954 44 24C44 35.046 35.046 44 24 44ZM22 6H26V26H22V6ZM22 22H42V26H22V22Z"
                    fill="#C1C7CD"
                  />
                </svg>
              </div>
              <div className="cf-box-name">Compliance Officer</div>
              <a href="mailto:support@apnakonnect.com">
              <div className="cf-box-mail">
                <span className="contact-title"> Email</span>
              </div>
              </a>
              {/* <div className="cf-box-contact">
                <div className="contact-title">Contact</div>

                <div className="arrow">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15.586 10.6569L11.636 6.70692C11.4538 6.51832 11.353 6.26571 11.3553 6.00352C11.3576 5.74132 11.4628 5.49051 11.6482 5.3051C11.8336 5.11969 12.0844 5.01452 12.3466 5.01224C12.6088 5.00997 12.8614 5.11076 13.05 5.29292L18.707 10.9499C18.8002 11.0426 18.8741 11.1527 18.9246 11.2741C18.9751 11.3954 19.001 11.5255 19.001 11.6569C19.001 11.7883 18.9751 11.9184 18.9246 12.0398C18.8741 12.1611 18.8002 12.2713 18.707 12.3639L13.05 18.0209C12.9578 18.1164 12.8474 18.1926 12.7254 18.245C12.6034 18.2974 12.4722 18.325 12.3394 18.3262C12.2066 18.3273 12.0749 18.302 11.952 18.2517C11.8291 18.2015 11.7175 18.1272 11.6236 18.0333C11.5297 17.9394 11.4555 17.8278 11.4052 17.7049C11.3549 17.582 11.3296 17.4503 11.3307 17.3175C11.3319 17.1847 11.3595 17.0535 11.4119 16.9315C11.4643 16.8095 11.5405 16.6992 11.636 16.6069L15.586 12.6569H6C5.73478 12.6569 5.48043 12.5516 5.29289 12.364C5.10536 12.1765 5 11.9221 5 11.6569C5 11.3917 5.10536 11.1373 5.29289 10.9498C5.48043 10.7623 5.73478 10.6569 6 10.6569H15.586Z"
                      fill="#0F62FE"
                    />
                  </svg>
                </div>
              </div> */}
            </div>
            <div className="cf-right-boxes">
              <div className="cf-box-icon">
                <svg
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M26.0006 28.0001H30.0006C30.531 28.0001 31.0397 28.2108 31.4148 28.5859C31.7899 28.9609 32.0006 29.4696 32.0006 30.0001C32.0006 30.5305 31.7899 31.0392 31.4148 31.4143C31.0397 31.7894 30.531 32.0001 30.0006 32.0001H24.0006C23.4702 32.0001 22.9615 31.7894 22.5864 31.4143C22.2113 31.0392 22.0006 30.5305 22.0006 30.0001V22.0001C22.0006 21.4696 22.2113 20.9609 22.5864 20.5859C22.9615 20.2108 23.4702 20.0001 24.0006 20.0001C24.531 20.0001 25.0397 20.2108 25.4148 20.5859C25.7899 20.9609 26.0006 21.4696 26.0006 22.0001V28.0001ZM22.0006 13.4641V12.0001C22.0006 11.4696 22.2113 10.9609 22.5864 10.5859C22.9615 10.2108 23.4702 10.0001 24.0006 10.0001C24.531 10.0001 25.0397 10.2108 25.4148 10.5859C25.7899 10.9609 26.0006 11.4696 26.0006 12.0001V13.4641C26.7632 13.0238 27.3591 12.3442 27.6961 11.5307C28.0331 10.7172 28.0922 9.81522 27.8643 8.96469C27.6364 8.11416 27.1342 7.36259 26.4356 6.82655C25.7371 6.29052 24.8811 5.99997 24.0006 5.99997C23.1201 5.99997 22.2641 6.29052 21.5655 6.82655C20.867 7.36259 20.3648 8.11416 20.1369 8.96469C19.909 9.81522 19.9681 10.7172 20.3051 11.5307C20.642 12.3442 21.238 13.0238 22.0006 13.4641ZM17.9186 15.1961C16.9253 14.0337 16.286 12.611 16.0762 11.0965C15.8665 9.58207 16.0951 8.03919 16.735 6.65062C17.375 5.26204 18.3994 4.08593 19.6871 3.26154C20.9747 2.43716 22.4717 1.99902 24.0006 1.99902C25.5295 1.99902 27.0265 2.43716 28.3141 3.26154C29.6018 4.08593 30.6262 5.26204 31.2661 6.65062C31.9061 8.03919 32.1347 9.58207 31.9249 11.0965C31.7152 12.611 31.0758 14.0337 30.0826 15.1961C33.509 16.606 36.34 19.1611 38.0927 22.4254C39.8454 25.6898 40.4112 29.4611 39.6935 33.0961C38.9758 36.731 37.0191 40.0044 34.1573 42.3576C31.2954 44.7109 27.7057 45.9982 24.0006 46.0001C20.2929 46.0029 16.6993 44.718 13.834 42.365C10.9687 40.0119 9.00953 36.7368 8.29134 33.0993C7.57316 29.4619 8.14054 25.6879 9.89651 22.4224C11.6525 19.1569 14.4881 16.6026 17.9186 15.1961ZM24.0006 42.0001C25.5765 42.0001 27.1369 41.6897 28.5928 41.0866C30.0487 40.4836 31.3716 39.5997 32.4859 38.4854C33.6002 37.371 34.4841 36.0482 35.0871 34.5923C35.6902 33.1364 36.0006 31.5759 36.0006 30.0001C36.0006 28.4242 35.6902 26.8638 35.0871 25.4079C34.4841 23.952 33.6002 22.6291 32.4859 21.5148C31.3716 20.4005 30.0487 19.5166 28.5928 18.9135C27.1369 18.3105 25.5765 18.0001 24.0006 18.0001C20.818 18.0001 17.7657 19.2644 15.5153 21.5148C13.2649 23.7652 12.0006 26.8175 12.0006 30.0001C12.0006 33.1827 13.2649 36.2349 15.5153 38.4854C17.7657 40.7358 20.818 42.0001 24.0006 42.0001Z"
                    fill="#C1C7CD"
                  />
                </svg>
              </div>
              <div className="cf-box-name">Chief Compliance Officer</div>
              <div className="cf-box-mail">
              <a href="mailto:support@apnakonnect.com">
              <div className="cf-box-mail">
                <span className="contact-title"> Email</span>
              </div>
              </a>
              </div>
              {/* <div className="cf-box-contact">
                <div className="contact-title">Contact</div>

                <div className="arrow">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15.586 10.6569L11.636 6.70692C11.4538 6.51832 11.353 6.26571 11.3553 6.00352C11.3576 5.74132 11.4628 5.49051 11.6482 5.3051C11.8336 5.11969 12.0844 5.01452 12.3466 5.01224C12.6088 5.00997 12.8614 5.11076 13.05 5.29292L18.707 10.9499C18.8002 11.0426 18.8741 11.1527 18.9246 11.2741C18.9751 11.3954 19.001 11.5255 19.001 11.6569C19.001 11.7883 18.9751 11.9184 18.9246 12.0398C18.8741 12.1611 18.8002 12.2713 18.707 12.3639L13.05 18.0209C12.9578 18.1164 12.8474 18.1926 12.7254 18.245C12.6034 18.2974 12.4722 18.325 12.3394 18.3262C12.2066 18.3273 12.0749 18.302 11.952 18.2517C11.8291 18.2015 11.7175 18.1272 11.6236 18.0333C11.5297 17.9394 11.4555 17.8278 11.4052 17.7049C11.3549 17.582 11.3296 17.4503 11.3307 17.3175C11.3319 17.1847 11.3595 17.0535 11.4119 16.9315C11.4643 16.8095 11.5405 16.6992 11.636 16.6069L15.586 12.6569H6C5.73478 12.6569 5.48043 12.5516 5.29289 12.364C5.10536 12.1765 5 11.9221 5 11.6569C5 11.3917 5.10536 11.1373 5.29289 10.9498C5.48043 10.7623 5.73478 10.6569 6 10.6569H15.586Z"
                      fill="#0F62FE"
                    />
                  </svg>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ContactUs;
